import {
  Radio,
  RadioGroup,
  RadioGroupProps,
  RadioState,
  useRadioState,
} from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useEffect } from 'react'
import { GroupLabel } from '../GroupLabel'

type Props = {
  name: string
  form: FormState
  values: Array<{ value: string; label: React.ReactNode }>
  defaultValue?: RadioState['value']
} & Partial<RadioGroupProps>

export function RadioInput(props: Props) {
  const { name, form, defaultValue, label, values, ...rest } = props

  const value: RadioState['value'] = useWatch({ name, form })

  const radioState = useRadioState({ defaultValue, orientation: 'horizontal' })

  useEffect(() => {
    if (!!value && value !== radioState.value) {
      radioState.setValue(value)
    }
  }, [radioState, value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    form.setValue(name, e.target.value)

  return (
    <RadioGroup
      label={label ? <GroupLabel>{label}</GroupLabel> : null}
      state={radioState}
      onChange={handleChange}
      {...rest}
    >
      {values.map(({ value, label }) => (
        <Radio key={value} value={value} label={label} />
      ))}
    </RadioGroup>
  )
}
